export const REGULAR_WORKSHOPS = "/regular_workshops";

export const ONLINE_WORKSHOPS = "/online_workshops";
export const ONLINE_WORKSHOPS_TYPE = "online_workshops";
export const ONLINE = '/online';
export const WEBINARS = "/webinars";
export const WEBINARS_WORKSHOPS_TYPE = "webinars";
export const PROVIDER_MY_WEBINARS = "/provider_my_webinars";
export const GROUP_SUPERVISION = "/group_supervision";
export const PUBLIC_WEBINARS = '/public_webinars';
export const PUBLIC_WORKSHOPS = '/public_workshops';
export const GROUP_WORKSHOPS_TYPE = "group_supervision";
export const PUBLIC_WORKSHOPS_TYPE = "public_workshop";
export const PROVIDER_MY_GROUP_SUPERVISION = "/provider_my_group_supervision";
export const POVIDER_MY_PUBLIC_WEBINARS = '/provider_my_public_webinars';
export const POVIDER_MY_PUBLIC_WORKSHOPS = '/provider_my_public_workshops';
export const PROVIDER_MY_WEBINARS_TYPE = "provider_my_webinars";
export const PROVIDER_MY_GROUP_SUPERVISION_TYPE = "provider_my_group_supervision";
export const PROVIDER_MY_PUBLIC_WEBINARS_TYPE = "provider_my_public_webinars";
export const PROVIDER_MY_PUBLIC_WORKSHOPS_TYPE = "provider_my_public_workshops";
export const THERAPY_PROVIDERS = "/provider_bios";
export const CREATE_COURSE_ONLINE = '/create_course_online';
export const MY_ORGANIZATION_WORKSHOPS = '/provider/my_org_workshops';

export const PURCHASED = "/purchased";

// export const MY_REGULAR_WORKSHOPS = "/my_regular_workshops";
// export const MY_REGULAR_WORKSHOPS_TYPE = "my_regular_workshops";

export const COMPLETED_WORKSHOPS = "/completed_workshops";
export const INPROGRESS_WORKSHOP = "/inprogress_workshops";

export const PROVIDER_MY_WORKSHOP = "/provider_my_workshops";
export const PROVIDER_MY_WORKSHOP_TYPE = "provider_my_workshops";

export const PROVIDER_TRAINEE_RESPONSES = "/provider/trainee_responses";
export const PROVIDER_IN_SOLD = "/provider/sold";
export const CREATE_ONLINE_WORKSHOP = "/createworkshop";

export const MY_REGULAR_WORKSHOPS = "/provider/my_reg_workshops";

export const PROVIDERS = "/providers";

export const MY_CPD_CERT_TEMPLATE = '/provider/cpd_cert_template';
export const PROVIDER_ORG_DETAILS = '/provider/org';

export const WORKSHOP_TYPES = {
  group_supervision: 3,
  online: 1,
  webinars: 2,
  public_webinars: 3,
  public_workshops: 5,
  regular_workshops: 0,
}



// WEBPACK FOOTER //
// ./src/stores/WorkshopsUrlConstants.js